// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

const ElementContainer = styled<any, Theme>('div')`
  box-sizing: border-box;
  padding: 1rem 0;
`;

export default ElementContainer;
